/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Grid } from '@material-ui/core';
import React, { Fragment, useMemo, useState } from 'react';
import styles from './CompareHashtags.module.scss';
import DotsMap from 'app/components/DotsMap';
import DataLabelChart from 'app/components/Charts/DataLabel';
import { _t } from 'app/utils/i18n';
import PieChart from 'app/components/Charts/PieChart';
import StackedColumnChart from 'app/components/StackedColumnChart/StackedColumnChart';
import TweetsColumnTabs from 'trends/components/TweetsColumnTabs';
import SecondaryTable from 'app/components/Tables/SecondaryTable';
import { path } from 'app/utils/path';
import {
  apiRoutes,
  apiRoutes as hashtagsApiRoutes,
} from 'hashtags/utils/apiRoutes';

import CustomColumnChart from 'app/components/Charts/CustomColumnChart';

import { Link, useHistory } from 'react-router-dom';
import { nFormatter } from 'app/utils/numbersFormater';
import { useMutation, useQueryClient } from 'react-query';
import TweetBoxForHashtags from 'app/components/TweetBoxForHashtags';
import { checkTranslated } from 'app/utils/helpers';
import { useModal } from 'app/context/Modal';
import { storeInfluencerName } from 'influencers/Requests';
import { toast } from 'react-toastify';
import ErrorBoundary from 'app/components/ErrorBoundary';
import AddComment from 'reports/components/AddComment';
import { useReport } from 'reports/pages/AddNewReport/AddNewReport';
import { navigateWithSearchState } from 'app/utils/search-state';
import { extractTitleOrSubTileOrReportNameOrDesc } from 'reports/utils/utils';

const NewCompareCharts = ({
  currentComparedHashtags,
  compareHashtagsList,
  currentTopLangSeries,
  comparedHashtagsNames,
  sentimentAnalysis,
  comparedHashtagsIds,
  isReport,
  showSlugs,
  isTemplate,
  reportState,
  currentTotalPosts,
  isSample,
  items,
}: {
  [key: string]: any;
}) => {
  const queryClient = useQueryClient();
  const modal = useModal();
  const history = useHistory();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [influencerName, setInfluencerName] = useState('');
  const report = useReport();
  const checkIsReport = (report: any, notReport: any = undefined) =>
    isReport && !isTemplate ? report : notReport;

  const itemsSlugs = showSlugs || report?.values?.slugs;
  const isTrendingModule = window?.location?.pathname?.includes('trends');

  const modules: string[] =
    queryClient.getQueryData('getAuthorizedModules') || [];

  const { mutateAsync: addInfluncerNameMutateAsync } = useMutation(
    storeInfluencerName,
    {
      onSuccess: (data: any) => {
        modal.hide();
        history.push(
          `${path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI}/${data?.id}`,
        );
        toast.success(<span>{_t('influencers:added_influencer')}</span>);
      },
      onError: (err: any) => {
        modal.hide();
        toast.error(<span>{err?.response?.data?.message}</span>);
      },
    },
  );
  const openModalToAddinfluencer = (name: string) => {
    modal.show({
      message: _t('hashtags:add_influencer_as_unanalyzes'),
      onOk: () => {
        addInfluncerNameAsUnanalyzed(name);
      },
      openLink: `https://twitter.com/${name}`,
      linkText: _t('hashtags:open_in_twitter'),
    });
  };
  const addInfluncerNameAsUnanalyzed = async (name: string) => {
    const result = await addInfluncerNameMutateAsync({
      username: name,
    });
    return result;
  };

  const transformTotalPosts = () => {
    return currentTotalPosts?.map((item: any) => {
      return Object.values(item).reduce((t, n: any) => t + n);
    });
  };
  const influencerColumns = [
    {
      title: _t('hashtags:influencer_entity'),
      key: 'name',
      render: (val: any, row: any) =>
        row.id > 0 ? (
          modules.includes('INFLUENCERS') && !row?.is_entity ? (
            <Link
              to={`${
                row?.status === 'ANALYZED'
                  ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                  : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
              }/${row?.id}`}
              title={checkTranslated(row?.name?.original, row?.name?.arabic)}
            >
              {checkTranslated(row?.name?.original, row?.name?.arabic)}
            </Link>
          ) : modules.includes('ENTITIES') && row?.is_entity ? (
            <Link
              to={`${
                row?.status === 'ANALYZED'
                  ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                  : path.entities.UN_ANALYZED_ENTITIES_DETAILS_URI
              }/${row?.id}`}
              title={checkTranslated(row?.name?.original, row?.name?.arabic)}
            >
              {checkTranslated(row?.name?.original, row?.name?.arabic)}
            </Link>
          ) : (
            <a
              className="cursor-pointer"
              onClick={() => {
                !modules.includes('INFLUENCERS')
                  ? modal.show({
                      isAlternative: true,
                      message: _t(`basic:you_are_not_authorize`),
                    })
                  : !modules.includes('ENTITIES') &&
                    modal.show({
                      isAlternative: true,
                      message: _t(`basic:you_are_not_authorize`),
                    });
              }}
            >
              {checkTranslated(row?.name?.original, row?.name?.arabic)}
            </a>
          )
        ) : (
          <p
            className="cursor-pointer "
            onClick={() => {
              openModalToAddinfluencer(row?.name?.original),
                setInfluencerName(row?.name?.original);
            }}
          >
            {checkTranslated(row?.name?.original, row?.name?.arabic)}
          </p>
        ),
    },
    {
      title: _t('hashtags:followers'),
      key: 'followers',
      render: (item: any) => nFormatter(item),
    },
    //DELETE COUNTRY FOR NOW
    // {
    //   title: _t('hashtags:country'),
    //   key: 'country',
    // },
    // {
    //   title: 'basic:translation',
    //   key: 'name',
    //   render: (val: any, row: any) => (
    //     <>
    //       {row?.name_translated?.length > 0 ? (
    //         <ToolTipComp
    //           title={checkHoveringTranslated(
    //             row.name?.original,
    //             row.name?.arabic
    //           )}
    //         >
    //           <LanguageIcon />
    //         </ToolTipComp>
    //       ) : (
    //         <p> - </p>
    //       )}
    //     </>
    //   ),
    // },
  ];
  type TRenderCharts = { id: string; component: JSX.Element }[];

  const renderCharts: TRenderCharts = [
    /*    {
      id: 'hashtags_compare_hashtags_first_mention_1',
      component: (
        <>
          {currentComparedHashtags?.map((hashtag: any, index: number) => {
            return (
              <Grid item lg={checkIsReport(6, 4)} md={6} xs={12} key={index}>
                <ErrorBoundary>
                  <TweetBoxForHashtags
                    showPlatformIcon={true}
                    title={
                      _t('trends:first_mention') +
                      ' ' +
                      checkTranslated(
                        hashtag?.hashtag_name,
                        hashtag?.hashtag_name_translated,
                      )
                    }
                    data={hashtag.first_tweet}
                    spaceBetween
                    tweetInHashtag
                    compId={`hashtags_compare_hashtags_first_mention_${
                      index + 1
                    }`}
                    additionalComponents={checkIsReport(
                      <AddComment
                        compId={`hashtags_compare_hashtags_first_mention_1`}
                        id={hashtag?.id}
                        {...reportState}
                      />,
                    )}
                    isReport={isReport}
                  />
                </ErrorBoundary>
              </Grid>
            );
          })}
        </>
      ),
    }, */
    {
      id: 'hashtags_compare_hashtags_total_posts',
      component: (
        <>
          <Grid item lg={checkIsReport(6, 4)} md={6} xs={12}>
            <ErrorBoundary>
              <DataLabelChart
                dataLabelTitle={_t(`hashtags:total_posts`)}
                showLegend
                customTooltip
                customTooltipData={currentTotalPosts}
                data={{
                  labels: comparedHashtagsNames,
                  series: transformTotalPosts(),
                }}
                compId={`hashtags_compare_hashtags_total_posts`}
                additionalComponents={checkIsReport(
                  <AddComment
                    compId={`hashtags_compare_hashtags_total_posts`}
                    {...reportState}
                  />,
                )}
                isReport={isReport}
              />
            </ErrorBoundary>
          </Grid>
        </>
      ),
    },
    {
      id: 'hashtags_compare_hashtags_top_countries_world_map',
      component: (
        <>
          {currentComparedHashtags.length !== 0 ? (
            <Grid item md={6} xs={12} className={styles.DotsMapStyle}>
              <ErrorBoundary>
                <DotsMap
                  showToolTip
                  page="compare"
                  data={currentComparedHashtags}
                  compId="hashtags_compare_hashtags_top_countries_world_map"
                  expandAction={() =>
                    history.push(
                      navigateWithSearchState(
                        isTrendingModule
                          ? path.trends.TOP_COUNTRIES_WORLD_MAP
                          : path.hashtags.TOP_COUNTRIES_WORLD_MAP,
                        {
                          data: hashtagsApiRoutes().compareHashtags,
                          customFilters: { hashtag_ids: comparedHashtagsIds },
                          type: 'dots',
                          page: 'compare',
                          currentModule: 'hashtags',
                        },
                      ),
                    )
                  }
                  currentModule="hashtags"
                  title={_t('trends:compare_on_world_map')}
                  additionalComponents={checkIsReport(
                    <AddComment
                      compId={`hashtags_compare_hashtags_top_countries_world_map`}
                      {...reportState}
                    />,
                  )}
                  isReport={isReport}
                />
              </ErrorBoundary>
            </Grid>
          ) : (
            <></>
          )}
        </>
      ),
    },
    {
      id: 'hashtags_compare_hashtags_engagements',
      component: (
        <>
          <Grid item lg={checkIsReport(6, 4)} md={6} xs={12}>
            <ErrorBoundary>
              <DataLabelChart
                dataLabelTitle={_t(`trends:engagement`)}
                showLegend
                hideTooltip
                data={{
                  labels: comparedHashtagsNames,
                  series: currentComparedHashtags?.map(
                    (v: any) => v?.['engagements'],
                  ),
                }}
                compId={`hashtags_compare_hashtags_engagements`}
                additionalComponents={checkIsReport(
                  <AddComment
                    compId={`hashtags_compare_hashtags_engagements`}
                    {...reportState}
                  />,
                )}
                isReport={isReport}
              />
            </ErrorBoundary>
          </Grid>
        </>
      ),
    },
    {
      id: 'hashtags_compare_hashtags_total_mentions',
      component: (
        <>
          <Grid item lg={checkIsReport(6, 4)} md={6} xs={12}>
            <ErrorBoundary>
              <DataLabelChart
                dataLabelTitle={_t(`trends:total_mentions`)}
                showLegend
                hideTooltip
                data={{
                  labels: comparedHashtagsNames,
                  series: currentComparedHashtags?.map(
                    (v: any) => v?.['mentions_count'],
                  ),
                }}
                compId={`hashtags_compare_hashtags_total_mentions`}
                additionalComponents={checkIsReport(
                  <AddComment
                    compId={`hashtags_compare_hashtags_total_mentions`}
                    {...reportState}
                  />,
                )}
                isReport={isReport}
              />
            </ErrorBoundary>
          </Grid>
        </>
      ),
    },
    {
      id: 'hashtags_compare_hashtags_sentiment',
      component: (
        <>
          {sentimentAnalysis ? (
            <Grid item md={6} xs={12}>
              <ErrorBoundary>
                <StackedColumnChart
                  showLegend
                  noLegendPercentage
                  isHorizontal={true}
                  compId={'hashtags_compare_hashtags_sentiment'}
                  stackedColumnTitle={_t('trends:sentiment')}
                  hideTimeFilter
                  hideCountryFilter
                  hidePlatformFilter
                  data={{
                    xaxis: comparedHashtagsNames,
                    values: !!sentimentAnalysis?.length
                      ? sentimentAnalysis
                          ?.map((item: any) => ({
                            ...item,
                            data: item?.data?.map(
                              (num: number) => Math.round(num * 10) / 10,
                            ),
                          }))
                          .reverse()
                      : [],
                  }}
                  unAnalyzed={sentimentAnalysis?.length == 0}
                  showToolTip
                  isSentiment
                  additionalComponents={checkIsReport(
                    <AddComment
                      compId={'hashtags_compare_hashtags_sentiment'}
                      {...reportState}
                    />,
                  )}
                  isReport={isReport}
                />
              </ErrorBoundary>
            </Grid>
          ) : (
            <></>
          )}
        </>
      ),
    },
    {
      id: 'hashtags_compare_hashtags_top_languages',
      component:
        currentTopLangSeries?.length !== 0 ? (
          <Grid item md={6} xs={12}>
            <ErrorBoundary>
              <StackedColumnChart
                // showLegend
                stackedColumnTitle={_t('trends:Top_Languages')}
                compId={'hashtags_compare_hashtags_top_languages'}
                showToolTip
                columnHeader={[_t('language'), _t('number')]}
                hideCountryFilter
                hideTimeFilter
                isHorizontal={true}
                hidePlatformFilter
                toolTipLimit={5}
                data={{
                  xaxis: comparedHashtagsNames,
                  values: currentTopLangSeries,
                }}
                noLegendPercentage
                additionalComponents={checkIsReport(
                  <AddComment
                    compId={'hashtags_compare_hashtags_top_languages'}
                    {...reportState}
                  />,
                )}
                isReport={isReport}
              />
            </ErrorBoundary>
          </Grid>
        ) : (
          <></>
        ),
    },
    {
      id: 'hashtags_compare_hashtags_mentions',
      component: (
        <Grid item lg={6} md={6} xs={12}>
          <ErrorBoundary>
            <CustomColumnChart
              basicColumnTitle={_t('trends:Mentions')}
              mentionsTooltip
              showToolTip
              timeIntervalFilter={!isReport}
              slug={hashtagsApiRoutes().mentionsChart}
              customFilters={{
                hashtag_ids: comparedHashtagsIds,
                time_interval: isReport ? 'YEAR' : 'MONTH',
                is_sample: isSample,
              }}
              monthTimeIntervalWithoutDay
              compId="hashtags_compare_hashtags_mentions"
              additionalComponents={checkIsReport(
                <AddComment
                  compId="hashtags_compare_hashtags_mentions"
                  {...reportState}
                />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ),
    },
    {
      id: 'hashtags_compare_hashtags_mentions_percentage',
      component: (
        <>
          {comparedHashtagsIds?.length ? (
            <Grid item lg={4} md={6} xs={12}>
              <ErrorBoundary>
                <PieChart
                  hideFilter
                  data={{
                    labels: comparedHashtagsNames,
                    series: currentComparedHashtags?.map(
                      (v: any) => v?.['mentions_count'],
                    ),
                  }}
                  ids={[...new Set(comparedHashtagsIds)] as any}
                  compId="hashtags_compare_hashtags_mentions_percentage"
                  pieTitle={_t('trends:mentions_percentage')}
                  translateData
                  additionalComponents={checkIsReport(
                    <AddComment
                      compId="hashtags_compare_hashtags_mentions_percentage"
                      {...reportState}
                    />,
                  )}
                  isReport={isReport}
                />
              </ErrorBoundary>
            </Grid>
          ) : (
            <></>
          )}
        </>
      ),
    },
    /*    {
      id: 'hashtags_compare_hashtags_top_influencer_entity_1',
      component: (
        <>
          {currentComparedHashtags?.map((hashtag: any, index: number) => (
            <Grid
              item
              lg={4}
              md={checkIsReport(12, 6)}
              xl={checkIsReport(6)}
              xs={12}
              key={hashtag.id}
            >
              <ErrorBoundary>
                <SecondaryTable
                  tableCardTitle={`${_t(
                    'trends:Top_Influencer_Entity',
                  )} #${checkTranslated(
                    hashtag.hashtag_name,
                    hashtag.hashtag_name_translated,
                  )}`}
                  hidePlatform
                  hideFilters
                  columns={influencerColumns}
                  hideToggleView={true}
                  // data={hashtag.influencers}
                  moduleName={hashtagsApiRoutes().topInfluencer}
                  customFilters={{
                    limit: 5,
                    hashtag_id: hashtag?.id,
                  }}
                  compId={`hashtags_compare_hashtags_top_influencer_entity_${
                    index + 1
                  }`}
                  additionalComponents={checkIsReport(
                    <AddComment
                      compId={
                        'hashtags_compare_hashtags_top_influencer_entity_1'
                      }
                      id={hashtag?.id}
                      {...reportState}
                    />,
                  )}
                  isReport={isReport}
                />
              </ErrorBoundary>
            </Grid>
          ))}
        </>
      ),
    }, */
  ];

  const renderPage = () => {
    if (isTemplate || items) {
      const paragraph = itemsSlugs
        ?.map((item: any) => extractTitleOrSubTileOrReportNameOrDesc(item))
        .filter(Boolean);
      const chartsFilter = renderCharts
        .filter((item) => item.id !== 'hashtags_compare_hashtags_tweets_column')
        ?.map((item) =>
          itemsSlugs?.some(
            (i: any) =>
              i?.slug === item?.id ||
              (i?.slug?.includes('tweets_column') &&
                item.id === 'hashtags_compare_hashtags_tweets_column'),
          )
            ? {
                ...item,
                order: itemsSlugs?.find((comp: any) => comp.slug === item.id)
                  ?.order,
              }
            : null,
        )
        .filter((item) => item?.component);

      return [...chartsFilter, ...paragraph]
        .sort((a, b) => a?.order - b?.order)
        .map((item) => item?.component);
    }

    if (isReport && report) return report?.renderCharts(renderCharts);

    return renderCharts.map((item, index) => (
      <Fragment key={index}>{item.component}</Fragment>
    ));
  };

  return <>{renderPage()}</>;
};

export default NewCompareCharts;
